/* @flow */
import React from 'react';

import Table from 'components/UIKit/Table';
import CasesColumns from './CasesColumns';
import CasesRows from './CasesRows';

type CasesTableProps = {
  router: Object,
  sort: string,
  order: string,
  children: any
}

export default function CasesTable({
  children, router, sort, order
}: CasesTableProps): React.Element {
  return (
    <Table customDataTestID="table-cases" >
      <CasesColumns sort={sort} order={order} />
      <CasesRows router={router}>
        {children}
      </CasesRows>
    </Table>
  );
}
